import { connect } from "react-redux"

import { getCurrentUser } from "../../../auth/selectors/currentUserGetters"
import withPageTitle from "../../../routes/containers/withPageTitle"
import { State } from "../../../store"
import AboutWrapper from "../components/AboutWrapper"

const mapStateToProps = (state: State) => ({
  user: getCurrentUser(state),
})

export default withPageTitle(
  "About",
  "Continuing Education As Easy As 1-2-3!™ 123 ConEd LLC is a leading online provider of continuing education courses to real estate professionals in Michigan."
)(connect(mapStateToProps)(AboutWrapper))
